import React from 'react'
import { Accordion, Card, Row } from 'react-bootstrap'

import styles from './AccordionToggle.module.scss'

export const AccordionToggle: React.FC<
  React.ComponentProps<Accordion['Toggle']>
> = ({ children, ...props }) => (
  <Card.Header className={styles.cardAccordionHeader}>
    <Accordion.Toggle className={styles.accordion} as={Row} {...props}>
      {children}
    </Accordion.Toggle>
  </Card.Header>
)
